module.exports = __webpack_public_path__ + "static/img/image4.17725afb.png";